import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiServices from "../../service";

const initialState: any = {
  clientActions: {
    listItems: [],

    activeItem: {},
    loading: false,
    activeItemloading: false,
  },
  notes: {
    listItems: [],

    activeItem: {},
    loading: false,
    activeItemloading: false,
  },
  timeAllocations: {
    listItems: [],

    activeItem: {},
    loading: false,
    activeItemloading: false,
  },
};
export const getContactClientActionsListItems = createAsyncThunk(
  "clientContacts/getContactClientActionsListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.contactClientAction.getList(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getContactClientActionsDetailById = createAsyncThunk(
  "clientContacts/getContactClientActionsDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.clientContacts.clientActions.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.appointment_id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);
export const getContactNotesListItems = createAsyncThunk(
  "clientContacts/getContactNotesListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.notes.getList(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getContactNotesDetailById = createAsyncThunk(
  "clientContacts/getContactNotesDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.clientContacts.notes.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find((item: any) => item.note_id === Id);
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const getContactTimeAllocationsListItems = createAsyncThunk(
  "clientContacts/getContactTimeAllocationsListItems",
  async (Id: string, { rejectWithValue }) => {
    try {
      const response: any = await apiServices.timeAllocation.getList(Id);

      const { isError, data } = response.data;
      if (isError || !data) {
        return rejectWithValue("Failed to fetch  list");
      }

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

export const getContactTimeAllocationsDetailById = createAsyncThunk(
  "clientContacts/getContactTimeAllocationsDetailById",
  async (Id: string, { getState, rejectWithValue }) => {
    if (!Id) return rejectWithValue("Invalid Id ID");

    // Access the current state
    const state: any = getState();

    const itemList = state.clientContacts.timeAllocations.listItems;

    // Find the valuation detail by ID in the listItems array
    const itemDetail = itemList.find(
      (item: any) => item.timeallocation_id === Id
    );
    if (itemDetail) {
      return itemDetail; // Return the detail if found
    } else {
      return rejectWithValue("item detail not found in state");
    }
  }
);

export const clientContactsSlice = createSlice({
  name: "clientContacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactClientActionsListItems.pending, (state) => {
        state.clientActions.loading = true;
        state.clientActions.listItems = [];
      })
      .addCase(getContactClientActionsListItems.fulfilled, (state, action) => {
        state.clientActions.loading = false;
        state.clientActions.listItems = action.payload;
      })
      .addCase(getContactClientActionsListItems.rejected, (state, action) => {
        state.clientActions.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getContactClientActionsDetailById.pending, (state) => {
        state.clientActions.activeItemloading = true;
        state.clientActions.activeItem = {};
      })
      .addCase(getContactClientActionsDetailById.fulfilled, (state, action) => {
        state.clientActions.activeItemloading = false;
        state.clientActions.activeItem = action.payload;
      })
      .addCase(getContactClientActionsDetailById.rejected, (state, action) => {
        state.clientActions.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      })
      .addCase(getContactNotesListItems.pending, (state) => {
        state.notes.loading = true;
        state.notes.listItems = [];
      })
      .addCase(getContactNotesListItems.fulfilled, (state, action) => {
        state.notes.loading = false;
        state.notes.listItems = action.payload;
      })
      .addCase(getContactNotesListItems.rejected, (state, action) => {
        state.notes.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getContactNotesDetailById.pending, (state) => {
        state.notes.activeItemloading = true;
        state.notes.activeItem = {};
      })
      .addCase(getContactNotesDetailById.fulfilled, (state, action) => {
        state.notes.activeItemloading = false;
        state.notes.activeItem = action.payload;
      })
      .addCase(getContactNotesDetailById.rejected, (state, action) => {
        state.notes.activeItemloading = false;
        console.error("Error fetching  details:", action.payload);
      })
      .addCase(getContactTimeAllocationsListItems.pending, (state) => {
        state.timeAllocations.loading = true;
        state.timeAllocations.listItems = [];
      })
      .addCase(
        getContactTimeAllocationsListItems.fulfilled,
        (state, action) => {
          state.timeAllocations.loading = false;
          state.timeAllocations.listItems = action.payload;
        }
      )
      .addCase(getContactTimeAllocationsListItems.rejected, (state, action) => {
        state.timeAllocations.loading = false;
        console.error("Error fetching  list:", action.payload);
      })
      .addCase(getContactTimeAllocationsDetailById.pending, (state) => {
        state.timeAllocations.activeItemloading = true;
        state.timeAllocations.activeItem = {};
      })
      .addCase(
        getContactTimeAllocationsDetailById.fulfilled,
        (state, action) => {
          state.timeAllocations.activeItemloading = false;
          state.timeAllocations.activeItem = action.payload;
        }
      )
      .addCase(
        getContactTimeAllocationsDetailById.rejected,
        (state, action) => {
          state.timeAllocations.activeItemloading = false;
          console.error("Error fetching  details:", action.payload);
        }
      );
  },
});
export const {} = clientContactsSlice.actions;
export default clientContactsSlice.reducer;
